module.exports = __webpack_public_path__ + "static/media/mikmak-circle-logo-white-transparent.40611fad.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/mikmak-circle-logo-white-transparent.png
// module id = 374
// module chunks = 0